export default {
    props: [
        "name",
        "uploadedFiles",
    ],
    emits: [
        "upload",
        "delete",
    ],
    methods: {
        openFilePicker() {
            document.getElementById(this.name + "-file").click();
        },
    },
    template: `
    <div class="custom-file-input-wrapper">
        <div class="custom-file-input-wrapper">
            <div v-for="(file, index) in uploadedFiles" :key="index" class="custom-file-input-container">
                <span class="custom-file-input-name" v-html="file.name"></span>
                <img @click="$emit('delete', index)" class="custom-file-input-icon" src="/cdn/shop/t/98/assets/close-small.svg">
            </div>
        </div>
        
        <label :for="name + '-file'">
            <button @click="openFilePicker" class="custom-file-input-button">
                <img src="/cdn/shop/t/98/assets/plus.svg" />
                Add files
            </button>
            <input @change="$emit('upload', $event?.target?.files)" type="file" multiple :id="name + '-file'" accept=".ai, .psd, .png, .pdf, .svg, .eps" class="custom-file-input-file ">
        </label>
    </div>
	`,
};